
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';

import projectGetActions from '../../sagas/project';
import createCommandItem from '../common/createCommandItem';
import DialogConfirm from '../common/DialogConfirm';

const classNames = mergeStyleSets({
    root: {
    }
});

const COMMAND_REFRESH = {
    key: 'refresh',
    name: 'Znovu načíst',
    iconName: 'Refresh'
};

const COMMAND_IMPORT_KN = {
    key: 'importKnData',
    name: 'Import dat KN',
    iconName: 'Installation'
};

const COMMAND_DELETE = {
    key: 'delete',
    name: 'Smazat projekt',
    iconName: 'Delete'
};

const ProjectCommandBar = (props) => {

    const dispatch = useDispatch();
    const projectActions = projectGetActions(dispatch);

    const token = useSelector(state => {
        return state.auth.data ? state.auth.data.user.token : null;
    });

    const projectId = props.project.data.project.id;

    const handleRefresh = () => {
        projectActions.refresh(token, projectId);
    }

    const handleImportKn = async () => {
        const message = `Opravdu chcete naimportovat do projektu nová data? <br/><br/>Veškerá aktuální data v projektu budou nenávratně smazána.`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            projectActions.importKnData(token, projectId);
        }
    }

    const handleDelete = async () => {
        const message = `Opravdu chcete smazat projekt "<b>${props.project.data.project.title}</b>"? <br/><br/>Data budou nenávratně smazána.`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            projectActions.delete(token, projectId);
        }
    }

    let commandItems = [];
    commandItems.push(createCommandItem(COMMAND_REFRESH, handleRefresh));
    commandItems.push(createCommandItem(COMMAND_IMPORT_KN, handleImportKn));
    commandItems.push(createCommandItem(COMMAND_DELETE, handleDelete));

    return (
        <div className={classNames.root}>
            <CommandBar
                farItems={commandItems}
            />
        </div>
    )
}

export default ProjectCommandBar;
